
function addToCart(event) {
          console.log(event)
         var product_id = event.target.getAttribute('data-productid');
         var variant_id = event.target.getAttribute('data-variantid');
         let formData = {
             'items': [{
               'id': variant_id,
                'quantity': 1,
             }],
            sections: "cart-drawer,cart-icon-bubble,cart-live-region-text",
            sections_url: window.location.pathname
         };
         const route = window.Shopify.routes.root ?
           window.Shopify.routes.root + 'cart/add.js' :
           window.Shopify.routes.cart_url + '/add.js' ;

         fetch(route, {
             method: 'POST',
             headers: {
                 'Content-Type': 'application/json'
             },
             body: JSON.stringify(formData)
         })
         .then(response => response.json())
         .then(data => {
           renderSections(data.sections)})
         .catch((error) => {
             console.error('Error:', error);
         });
    }
    function renderSections(sections){
      for( section_id in sections ){
        let section = document.querySelector("#"+section_id);
        let section_html = sections[section_id];

        if(section_id == "cart-drawer") {
          section = document.querySelector('cart-drawer');
          if(section && section_html){
            section.outerHTML = section_html;
            showCartDrawer();
          }
        } else {
          if(section && section_html){
            section.innerHTML = section_html;
          }
        }

      }
    }
    function showCartDrawer() {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
          cartDrawer.classList.add('active');
      }
  }